import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { ApiAuthService } from '../../../services/api-auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-restablecer-contrasena',
  templateUrl: './restablecer-contrasena.component.html',
  styleUrls: ['./restablecer-contrasena.component.css']
})
export class RestablecerContrasenaComponent implements OnInit {
  public ResponseCaptcha: boolean = false;
  alerta: boolean = false; //Comportamiento del mensaje de error de las contraseñas no coinciden
  correo: string = ''; //Guarda el correo del que se esta restableciendola contraseña
  token: string = ''; //Guarda el token que se recibio en la url por correo

  contra: string = ''; //Variable para guadar la clase is-invalid que se agrega a las propiedades de los input
  nuevacontra: string = ''; //Variable para guadar la clase is-invalid que se agrega a las propiedades de los input

  errorContra: string = ''; //Guardar el mensaje de error de campo sin completar
  errorNuevaContra: string = ''; //Guardar el mensaje de error de campo sin completar

  public mensajeError: string = ''; //Guarda el mensaje de error en caso de ocurrir en el cambio de contraseña


  //Creacion del FormGroup con sus determinados campos y sus validators.
  createFormGroup() {
    return new FormGroup({
      contra: new FormControl('', Validators.required),
      nuevacontra: new FormControl('', Validators.required)
    });
  }

  contactForm: FormGroup;
  constructor(private router: Router, private apiAuth: ApiAuthService) {
    this.contactForm = this.createFormGroup();
    let token = this.router.routerState.snapshot.root.children[0].params.token;
    this.token = token;
    //checaToken => Revisa que el token leído aun este vigente y no haya sido usado.
    this.apiAuth.checaToken(token).subscribe(data => {
      console.log(data);
      if (data[0].success) {
        let respuesta = JSON.parse(data[0].info);
        console.log(respuesta);
        this.correo = respuesta[0].CORREO;
        if (respuesta[0].INDEST !== '0'){
            this.router.navigate(['/not-found']);
        }
      } else {
        this.router.navigate(['/not-found']);
      }
    },
    error => {
      $('#error').modal('show');
    });
  }

  ngOnInit() {
  }

  resolved(captchaResponse: string) {
    console.log(`Captcha resuelta con esta respuesta: ${captchaResponse}`);

    if (isNullOrUndefined(captchaResponse)) {
      this.ResponseCaptcha = false;
    } else {
      this.ResponseCaptcha = true;
    }
  }

  //Reestablecer la contraseña
  enviar() {
    if (this.validaCampos()) {
      $('#procesando').modal('show');
        this.alerta = false;
        let contra = this .contactForm.get('contra').value;
        //cambiarContra => Restablece la contraseña
        this.apiAuth.cambiarContra(this.correo, contra, this.token).subscribe(data => {
          if (data[0].success) {
            if (data[0].info === '0') {
              setTimeout( () => {
                $('#procesando').modal('hide');
                $('#success').modal('show');
              }, 500);
            } else {
              setTimeout( () => {
                $('#procesando').modal('hide');
                $('#error').modal('show');
              }, 500);
            }
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout( () => {
              $('#procesando').modal('hide');
              $('#error').modal('show');
            }, 500);
          }
        },
        error => {
          setTimeout( () => {
            $('#procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
    }
  }

  //Validacion de todos los campos completos
  validaCampos() {
    let bandValida = true;
    if (this.contactForm.controls.contra.hasError('required')) {
        this.contra = 'is-invalid';
        this.errorContra = 'Campo sin completar';
        bandValida = false;
    } else {
        this.contra = '';
        this.errorContra = '';
    }
    
    if (this.contactForm.controls.nuevacontra.hasError('required')) {
      this.nuevacontra = 'is-invalid';
      this.errorNuevaContra = 'Campo sin completar';
      bandValida = false;
    } else {
      this.nuevacontra = '';
      this.errorNuevaContra = '';
    }

    if (this.contactForm.get('contra').value !== this.contactForm.get('nuevacontra').value) {
      this.alerta = true;
        bandValida = false;
    }

    return bandValida;
  }

}
